module.exports = "/assets/afb643a4a70dcdcc62e90a4ab6350ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8Q.png
// module id = 1144
// module chunks = 0